import { Category } from '@/shared/model/category.ts';
import CategoryModalDelete from '../modals/CategoryModalDelete/CategoryModalDelete.tsx';
import { openModal, refreshCategories } from '../../hooks/useInit.ts';
import { ModalSize, RowAction, TableColumn } from '@fs/uikit-react';
import {
  CategoryModal,
  ModalMode
} from "@/pages/Operator/Category/components/modals/CategoryModal";

export const getTableColumns = (): TableColumn[] => {
  return [
    {
      key: 'name',
      title: 'Назва',
      width: '30%',
      sortable: true,
    },
    {
      key: 'color',
      title: 'Колір',
      width: '80px',
      render: (text: string, record: Category) => {
        const color = record.color || '#cccccc';
        return (
          <div style={{ display: 'flex', alignItems: 'center', height: 24 }}>
            <div
              style={{
                width: '100%',
                height: 16,
                backgroundColor: color,
              }}
            />
          </div>
        );
      }
    },
    {
      key: 'description',
      title: 'Опис',
      width: '55%',
    },
  ];
};

export const getRowActions = (handleDeleteCategory: (record: Category) => void): RowAction[] => {
  return [
    {
      type: 'delete',
      onClick: (record: Category) => {
        handleDeleteCategory(record);
      }
    }
  ];
};

export const filteredCategories = (categories: Category[], searchValue: string): Category[] => {
  if (searchValue === '') {
    return categories;
  }

  const searchLower = searchValue.toLowerCase();
  return categories.filter(c => (
    c.name.toLowerCase().includes(searchLower) ||
    (c.description?.toLowerCase().includes(searchLower))
  ));
};

export const handleCreateCategory = () => {
  openModal(
    ModalSize.SMALL,
    'Створити категорію',
    <CategoryModal mode={ModalMode.CREATE} onSuccess={refreshCategories} />
  );
};

export const handleEditCategory = (category: Category) => {
  openModal(
    ModalSize.SMALL,
    'Редагувати категорію',
    <CategoryModal mode={ModalMode.EDIT} category={category} onSuccess={refreshCategories} />
  );
};

export const handleDeleteCategory = (category: Category) => {
  openModal(
    ModalSize.SMALL,
    'Видалити категорію',
    <CategoryModalDelete category={category} onSuccess={refreshCategories} />
  );
};
